import {openResourceModal} from '../../core/modalCommand';
import {
	AIR_TIME_FAIRNESS_EDIT_MODAL_EVENT,
} from './events';

/**
 * Open Edit ATF for the resolved row.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openAirTimeFairnessEditModal(command, envelope) {
	return openResourceModal(AIR_TIME_FAIRNESS_EDIT_MODAL_EVENT, command, envelope);
}
